import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    collectivities: [],
    collectivity: {},
    managementEntity: {},
    zones: [],
    zone: {},
}

const store = createSlice({
    name: 'collectivity',
    initialState,
    reducers: {
        collectivity: (state, action) => {
            state.collectivity = action.payload
        },
        collectivities: (state, action) => {
            state.collectivities = action.payload
        },
        managementEntity: (state, action) => {
            state.managementEntity = action.payload
        },
        zones: (state, action) => {
            state.zones = action.payload
        },
        zone: (state, action) => {
            state.zone = action.payload
        },
    },
})

export const CollectivityActionConstant = store.actions
export default store.reducer